import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { map, switchMap } from 'rxjs/operators';
import { AuthRow } from './auth.defs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, from } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

	disableGuest = !!(environment.hasOwnProperty('disableGuest') ? environment['disableGuest'] : true);

	id = 0;
	email: string;
	username: string;

	guest = true;
	locked = false;
	sysadmin = false;

	valid = false;

	isValid = new BehaviorSubject<boolean>(false);

  	constructor(
          private _apiService: ApiService,
          private _http: HttpClient,
	  ) { }

	set(auth: AuthRow) {
		this.id = auth.id;
		this.guest = !!(auth.guest);
		this.sysadmin = !!(auth.sysadmin);
		this.email = auth.email;
		this.username = auth.login;
		this.valid = auth.id && !(this.disableGuest && auth.guest);

		this.isValid.next(this.valid);
		console.log('set', {auth, this: this, valid: this.valid});
	}

	login(creds: {login: string, password: string}) {
        const url = `${this._apiService.endpoint}/login`,
            form = new FormData();
        form.append('login', creds.login);
        form.append('password', creds.password);
        form.append('realm', this._apiService.spoke);

        return this._http.post(url, form, {
            withCredentials: false,
        })
        .pipe(
            map((r: {token: string}) => {
                if (r && r.token) {
                    this._apiService.token = r.token;
                }
                return r.token;
            }),
            switchMap(() => this._apiService.request<AuthRow>({'$/auth/current': {}})),
            map(auth => {
                this.set(auth);
                window.location.reload();
                return auth;
            })
        );
	}
}
